<template>
  <Transition name="toast">
    <div v-if="show" class="toast" :class="type">
      {{ message }}
    </div>
  </Transition>
</template>

<script setup>
import { ref } from 'vue';

const show = ref(false);
const message = ref('');
const type = ref('info');

const showToast = (options) => {
  message.value = options.message;
  type.value = options.type || 'info';
  show.value = true;
  setTimeout(() => {
    show.value = false;
  }, options.duration || 3000);
};

defineExpose({ showToast });
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.toast {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: $spacing-sm $spacing-lg;
  border-radius: $border-radius-md;
  background-color: rgba(#000, 0.8);
  color: white;
  font-size: 0.9rem;
  z-index: 1000;
  backdrop-filter: blur(4px);
  box-shadow: $shadow-md;

  &.error {
    background-color: rgba(#FF3B30, 0.9);
  }

  &.success {
    background-color: rgba(#34C759, 0.9);
  }
}

.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}
</style> 